import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { OrdQueryQueryI } from './models/ord-query-query.interface';

export const OrdQueryActions = createActionGroup({
    source: 'OrdQuery',
    events: {
        Set: props<{ query: OrdQueryQueryI; }>(),
        Sailing: props<{ hideSailings?: boolean; sailing?: string; }>(),
        SwitchView: emptyProps(),
        HideSearch: emptyProps(),
        ToggleSearch: emptyProps(),
        Reset: emptyProps(),
    },
});